<template>
  <div>
    <McLoading :isLoading="isSubmitting" />
    <b-modal
      id="modal-reset-timeline"
      class="mc-modal"
      :title="title"
      header-bg-variant="primary"
      size="md"
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <p class="mt-2 p-0">
        {{ message }}
      </p>
      <template #modal-footer>
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.back')"
          :disabled="isSubmitting"
          @click="$bvModal.hide('modal-reset-timeline')"
        />
        <McButton
          variant="primary"
          type="submit"
          :text="buttonText"
          :disabled="isSubmitting"
          @click="actionToReset"
        />
      </template>
    </b-modal>
  </div>
</template>
<script>
import McButton from '@/components/McButton'
import * as RO from '@/services/rest-api/lib/route-optimization'

export default {
  components: {
    McButton,
  },
  data() {
    return {
      isSubmitting: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    title() {
      return this.$t('routeOptimization.alert.resetTitle')
    },
    message() {
      return this.$t('routeOptimization.alert.resetMessage')
    },
    buttonText() {
      return this.$t('global.resetAsset')
    },
  },
  methods: {
    async actionToReset() {
      if (this.isSubmitting) return
      this.isSubmitting = true
      this.$bvModal.hide('modal-reset-timeline')

      try {
        const res = await RO.rollback(this.id)
        await this.$nextTick()
        this.$router.push({ name: 'Route Optimization Detail', params: { id: res.data.id } })
      } catch (error) {
        this.$mcToast.error(this.$t('global.somethingWentWrong'))
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>
